export const toastConstants = {
  TOAST_SUCCESS: 'TOAST_SUCCESS',
  TOAST_ERROR: 'TOAST_ERROR',
  TOAST_CLEAR: 'TOAST_CLEAR',
};
